import React, { Component } from "react";
import stepHandler from "../StepHandler.js";
import { InputElement } from "../../UI";
import { v4 as uuidv4 } from "uuid";
import {
  Button,
  Container,
  Center,
  Heading,
  Box,
  Text,
  Flex,
  Spacer,
  Separator,
  Link,
} from "@chakra-ui/react";

const WEBSITE_URL = process.env.REACT_APP_WEBSITE_URL;

function waitForNeuroID(callback, retryLimit = 20) {
  let attempts = 0;
  const interval = setInterval(() => {
    if (window.nid && typeof window.nid === "function") {
      callback(window.nid);
      clearInterval(interval);
    } else {
      attempts++;
      if (attempts >= retryLimit) {
        clearInterval(interval);
      }
    }
  }, 200);
}

class Welcome extends Component {
  constructor() {
    super();
    this.state = { loading: false };
  }
  componentDidMount() {
    this.props.trackFields("Welcome", ["zipCode"]);
    window.scrollTo(0, 0);

    waitForNeuroID((nid) => {
      let applicationId =
        this.props.applicationId || localStorage.getItem("applicationId");
      if (!applicationId) {
        applicationId = uuidv4();
        localStorage.setItem("applicationId", applicationId);
      }
      nid("identify", applicationId);
    });
  }

  handleSubmit = (event) => {
    event.preventDefault();
    if (this.props.form?.zipCode?.validationResults?.isValid) {
      this.setState({ loading: true });
      let applicationId =
        this.props.applicationId || localStorage.getItem("applicationId");
      if (!applicationId) {
        applicationId = uuidv4();
        localStorage.setItem("applicationId", applicationId);
      }
      waitForNeuroID((nid) => {
        nid("identify", applicationId);
      });
      this.props.next();
    }
  };

  handleContinue = () => {
    this.setState({ loading: true });
    const trySubmit = (retries = 5) => {
      let applicationId =
        this.props.applicationId || localStorage.getItem("applicationId");

      if (!applicationId) {
        if (retries > 0) {
          setTimeout(() => trySubmit(retries - 1), 400);
        } else {
          this.props.next();
        }
        return;
      }

      waitForNeuroID((nid) => {
        nid("identify", applicationId);
        nid("applicationSubmit");
      });

      this.props.next();
    };

    trySubmit();
  };

  render() {
    const { isTransitionPending } = this.props;

    if (document.getElementById("validResult") && !isTransitionPending) {
      document.getElementById("next-button").disabled = false;
    }

    let validated =
      this.props.form?.zipCode?.validationResults?.isValid ||
      (this.props.form?.state.value &&
        this.props.form?.zipCode?.value.length === 5)
        ? true
        : false;

    return (
      <Box mt={10} mb={20}>
        <Center>
          <Heading id="welcome" style={{ fontSize: "25px" }} mb={14} as="h1">
            Prequalify for a loan in just 5 minutes with{" "}
            <span style={{ color: "#2171A6", fontStyle: "italic" }}>
              no impact to your credit score!
            </span>
          </Heading>
        </Center>

        <Container maxW="510px">
          <Box>
            <Text as="b" fontSize="18px">
              <Text as="div" fontWeight="bold" fontSize="15px">
          Thank you for considering Republic Finance for your financial needs!
                    </Text>
            </Text>{" "}
            <Text fontSize="18px" mt={5}>
              The prequalification process is quick and easy. We’ll ask some
              basic information about you, your household, and your household
              income. We’ll then perform a{" "}
              <Link
                style={{ textDecoration: "underline", color: "#2171A6" }}
                target="_blank" rel="noopener noreferrer"
                color="teal.500"
                href="https://www.consumerfinance.gov/ask-cfpb/whats-a-credit-inquiry-en-1317/"
              >
                soft credit check
              </Link>{" "}
              so that means{" "}
              <span style={{ fontWeight: "bold" }}>
                {" "}
                your credit score is never affected!
              </span>{" "}
              You may be able to redeem your offer online or in your local
              Republic Finance branch.{" "}
              <Text fontSize="18px" mt={5}>
                We don’t yet offer loans in all states, so we’ll make sure we
                service your area, first.
              </Text>
            </Text>
            <Box mt={10} maxW={"150px"}>
              <form onSubmit={this.handleSubmit}>
                <InputElement
                  formElement={this.props.form.zipCode}
                  onChange={(event) => this.props.onChanged(event, "zipCode")}
                  onBlur={(event) => this.props.onBlurred(event, "zipCode")}
                />
              </form>
            </Box>
          </Box>
        </Container>
        <Center>
          {" "}
          {this.props.form?.zipCode?.validationResults?.isValid ? (
            <Box margin={5} p={10} maxW="510px" bg="#F8FCFF">
              It looks like you’re in{" "}
              <span style={{ fontWeight: "bold" }}>
                {this.props.form.zipCode.validationResults.validationSuccess}
                .{" "}
              </span>{" "}
              We have locations near you!
            </Box>
          ) : null}
        </Center>
        <Center>
          {" "}
          {this.props.form?.zipCode?.validationResults?.validationErrors ? (
            <Box margin={5} padding={10} maxW="500px" bg="#FFFBEF">
              {this?.props?.form?.zipCode?.validationResults?.validationErrors}{" "}
              {this?.props?.form?.zipCode?.validationResults?.validationLink ? (
                <a
                  style={{ textDecoration: "underline", color: "#2171A6" }}
                  href={`${WEBSITE_URL}/check`}
                >
                  loan check page.
                </a>
              ) : (
                ""
              )}
            </Box>
          ) : (
            ""
          )}
        </Center>
       <Center>
    <Box mt={10} maxW="510px" w="100%" borderTop="1px solid #ccc" />
</Center>
        <Container maxW="510px">
    <Flex justifyContent="flex-end">
        <Button
            id="next-button"
            onClick={this.handleContinue}
            disabled={!validated || isTransitionPending}
            bg="#2371a5"
            color="white"
            _hover={{ bg: "#3c99d3" }}
            size="md"
            mt={10}
            p={4}
            loading={this.state.loading}
            loadingText="Continue"
        >
            Continue
        </Button>
    </Flex>
</Container>
      </Box>
    );
  }
}

export default stepHandler(Welcome);
